document.addEventListener('DOMContentLoaded', () => {
    eggoSorting();
});

const eggoSorting = () => {
    const sortingForm = document.getElementById("eggo-sorting");
    if (!sortingForm) return;
    const sortingElement = sortingForm.querySelector('select');
    const helperElement = document.querySelector(".helper-element");

    if (!sortingElement || !helperElement) {
        return;
    }
    setTimeout(() => {
        initResize(sortingForm, sortingElement, helperElement);
    }, 200);
    sortingElement.addEventListener('change', () => {
        sortingForm.submit();
        initResize(sortingForm, sortingElement, helperElement);
    })
}


function initResize(parent, element, helperElement) {
    helperElement.innerHTML = element.querySelector(
        "option:checked"
    ).innerText;
    element.style.width = helperElement.offsetWidth + "px";
    parent.classList.add('calculated');
}